module.exports = __webpack_public_path__ + "static/media/car-service.03aab19f.svg";